import errorTemplate from './error.tpl.html';
import notFoundTemplate from './404.tpl.html';
import maintenanceTemplate from './maintenance.tpl.html';
import './error.route.less';
import { legalLinksComponentModule } from '../../components/legal-links/legal-links';
import { compileTemplateComponentModule } from '../../components/compile-template/compile-template';
import { appConfig } from '../../constants/app-config';
import { uiRouterStateModule } from '../../vendor/ui-router-module';
import { appAlertComponentModule } from '../../components/app-alert/app-alert';
import { switchTeamOnErrorDialogComponentModule } from '../../components/switch-team-on-error-dialog/switch-team-on-error-dialog';

export const errorRouteModule = angular
  .module('Q.routes.error', [
    uiRouterStateModule,
    legalLinksComponentModule,
    compileTemplateComponentModule,
    appAlertComponentModule,
    switchTeamOnErrorDialogComponentModule,
  ])

  .factory('objectNotFound', function ($q) {
    return function (type) {
      return $q.reject({
        status: 404,
        statusText: `${type ? type + ' ' : ''}Not Found`,
        itemLabel: type,
      });
    };
  })
  .factory('showObjectNotFound', function ($state) {
    return function (type) {
      return $state.go('error', {
        error: {
          status: 404,
          statusText: `${type ? type + ' ' : ''}Not Found`,
          itemLabel: type,
        },
      });
    };
  })

  .config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise(function ($injector) {
      // switch to error state without changing the URL
      $injector.get('$state').go('error');
    });

    // Checks to see if we can simply redirect to without showing a "hard" error
    // This is generally only for 404 and authorization errors
    const shouldRedirect = ($stateParams) => {
      const error = $stateParams.error;
      const toState = $stateParams.toState;
      const onError = toState && toState.data && toState.data.onError;
      return (
        error &&
        onError &&
        onError.sref &&
        [401, 403, 404].find((c) => error.status === c)
      );
    };

    $stateProvider.state('error', {
      params: {
        error: false,
        didLog: false,
        fromState: {},
        fromParams: {},
        toState: {},
        toParams: {},
        maintenanceEvent: null,
      },

      data: {
        bodyClass: 'error-route',
        pageTitle: /* @ngInject */ function ($stateParams) {
          return $stateParams.maintenanceEvent ? 'System Maintenance' : 'Error';
        },
      },

      template: function (stateParams) {
        if (shouldRedirect(stateParams)) {
          // don't render if we're going to redirect
          return '';
        } else if (stateParams.maintenanceEvent) {
          return maintenanceTemplate;
        } else if (stateParams.error && stateParams.error.status !== 404) {
          return errorTemplate;
        } else {
          return notFoundTemplate;
        }
      },
      controller: /* @ngInject */ function (
        $rootScope,
        $state,
        $stateParams,
        $log,
        $location,
        switchTeamOnErrorDialog,
        appAlert,
      ) {
        const ctrl = this;

        const toState = $stateParams.toState;
        const onError = (ctrl.onError =
          (toState && toState.data && toState.data.onError) ||
          appConfig.onError);
        const error = (ctrl.error = $stateParams.error);
        ctrl.itemLabel =
          (onError && onError.itemLabel) ||
          (error && error.itemLabel) ||
          'item';

        if (shouldRedirect($stateParams)) {
          $rootScope.showLoadingPanel = true;

          const errorData = error.data || {};
          if (errorData.switchTeam) {
            // let the user switch to the correct team
            switchTeamOnErrorDialog.open(
              $location.absUrl(),
              errorData.switchTeam,
              onError,
            );
          } else if (error.status === 404) {
            // show a simple banner alerting them to the missing object
            appAlert.error(
              `We're sorry, we were unable to find that ${ctrl.itemLabel}.`,
            );
          } else {
            // show a simpler banner showing access error
            appAlert.error(
              `We're sorry, but you do not have access to that ${ctrl.itemLabel}.`,
            );
          }

          // redirect immediately
          $state.go(onError.sref);
          return;
        }

        ctrl.maintenance = $stateParams.maintenanceEvent;
        ctrl.startTimeLater =
          ctrl.maintenance && new Date() < ctrl.maintenance.startTime;

        // only broadcast an error if we can't safely recover from it
        $rootScope.$broadcast('app.error');

        if (error) {
          if ($stateParams.fromState && $stateParams.fromState.name) {
            let msg = `Error transitioning from ${$stateParams.fromState.name}(${JSON.stringify($stateParams.fromParams)}) to ${toState.name}(${JSON.stringify($stateParams.toParams)})`;
            $log.error(msg, $stateParams.didLog ? '' : error);
          }
          ctrl.simpleError =
            !angular.isString(error.message) ||
            error.message.indexOf('\n') === -1;

          if (appConfig.appPath && appConfig.onResetReturn !== false) {
            ctrl.resetParams = `&go=${appConfig.onResetReturn || appConfig.appPath}/`;
          }
        }
      },
      controllerAs: 'error',
    });
  });
